/* jQuery plugin to serialize form fields even if not found inside a form */
(
	function($){
		"use strict";

		$.fn.serializeFields = function(opt){
			var opt = opt?opt:{},
				// Serialize object to store values
				srlz = {},
				// Allow keys to be uniquely named on input but stripped on output
				uniKey = opt.uniKey?opt.uniKey:"",
				// Only include fields that match the uniKey.
				uniKeyOnly = opt.uniKeyOnly?opt.uniKeyOnly:false,
				// multiArray if true converts multi-selects and checkboxes into array of values
				multiArray = typeof opt.multiArray === "boolean"?opt.multiArray:false,
				_strSrlz = "",
				key;

			// Since adding a value takes multiple lines, create function once
			function _doSerialize(v,o,multi){
				// Encode if opted as true or excluded
				var v = opt.encode !== false?encodeURIComponent(v):v,
					// Place id in var and strip unique key
					_id = (o.name != "")?o.name:o.id;

				if(uniKey !== "") {
					var uniRegex = new RegExp("^" + uniKey);
					if(uniKeyOnly && !uniRegex.test(_id)) {
						return;
					}
					_id = _id.replace(uniRegex, "");
				}
				// Serialize as JSON then conver to URL later if specified - for checkboxes/radios check to see if a previous value is saved
				if(multiArray && (o.attributes["multiple"] !== undefined || o.type === "checkbox" || o.type === "radio")){
					srlz[_id] = srlz[_id]?srlz[_id]:[];

					if(o.type === "checkbox" && $("#" + o.id).is(":checked")){
						srlz[_id].push(v);
					}
					else if(v !== "" && o.type !== "checkbox"){
						srlz[_id].push(v);
					}
				}
				else {
					srlz[_id] = (srlz[_id]?srlz[_id]:"") + ((v !== "" && srlz[_id])?",":"") + v;
				}
			};

			// Serialize drop downs
			$(this).find("select").each(
				function(){
					var _val = "";

					// Loop over all options in case it's multi-select
					for(var i=0,len=this.options.length;i < len;i++){
						if(this.options[i].selected){
							_doSerialize(this.options[i].value,this);
						}
					}
				}
			);

			// Serialize input tags
			$(this).find("input").each(
				function(){
					// Allow options to exclude those not checked
					if(
						(
							opt.checked &&
							(
								this.type === "checkbox" ||
								this.type === "radio"
							) &&
							this.checked
						)
						||
						(
							this.type !== "checkbox" &&
							this.type !== "radio"
						)
						||
						!opt.checked
					){
						_doSerialize(this.value,this);
					}
					else{
						_doSerialize("",this);
					}
				}
			);

			// Serialize textarea tags
			$(this).find("textarea").each(
				function(){
					_doSerialize(this.value,this);
				}
			);

			// If JSON is not the targeted output, convert to query string
			if((opt.type || "").toLowerCase() !== "json"){
				for(key in srlz){
					if(srlz.hasOwnProperty(key)){
						_strSrlz += ((_strSrlz != "")?"&":"") + key + "=" + srlz[key];
					}
				}
				// Re-assign return value
				srlz = _strSrlz;
			}

			return srlz;
		};
	}
)(jQuery);
